import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DataContext, { ContextProvider } from "./Components/Controller";
// import Main from './Components/Main';
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Landingpage from "./Components/Pages/Landingpage";
// import { useContext } from "react";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import TermsAndCondition from "./Components/Pages/TermsAndCondition";

function App() {
  return (
    <Router>
      <ContextProvider>
        <ToastContainer />
        <div className="w-full h-screen flex items-center justify-center mt-[1150px] md:mt-[550px]">
          <Routes>
            <Route path="/" element={<Landingpage />} />
            <Route path="/privacy_policy" element={<PrivacyPolicy />} />
            <Route path="/terms&condition" element={<TermsAndCondition />} />
          </Routes>
        </div>
      </ContextProvider>
    </Router>
  );
}

export default App;
